import React, {useState, useContext} from "react";
import { AppContext } from "../../App";
import { Button, TextField } from "@mui/material";
// import TextField from "@mui/material";

export default function ContractOpen(){

  const { activeUser, setChangesMade } = useContext(AppContext)

  const [openPar, setOpenPar] = useState(activeUser.contractOpen.openPar)

  const [editable, setEditable] = useState(true)

  const handleChange = (e) => {
    setOpenPar(e.target.value)
  }

  console.log(openPar)

  async function updateOpenPar(e){
    e.preventDefault()
    const updatedPar = {openPar}
    const user = localStorage.getItem("user")

    await fetch(`https://the-paper-pusher.herokuapp.com/updateOpenPar/${user}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(updatedPar)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
    setEditable(prev=>!prev)
    setChangesMade(prev => prev+1)
  }

  return (
    <div>
      <p className='confidential-clause'>
        <TextField
          name="openPar"
          variant="filled"
          multiline
          defaultValue={openPar}
          placeholder="Start writing your opening paragraph..."
          sx={{width: "100%"}}
          onChange={handleChange}
          disabled={!editable}
      />
        <Button hidden={editable} onClick={()=>{setEditable(prev=>!prev)}}>Edit</Button>
        <Button hidden={!editable} onClick={updateOpenPar} sx={{color: 'red'}}>save</Button>
      </p>
    </div>
  )
}